import {Button} from 'antd';

import {AdditionalInfo} from '../../../../../../../../../layout/additional-info/additional-info';
import {Locale} from '../../../../../../../../../provider/locale/localization';
import {AI_GENERATION_MAX_SLIDES} from '../../../../../../../../../service/posts/posts-hooks';

import {AiGenerationStepEnum} from './ai-generation-type';
import * as styles from './ai-generation-modal.scss';

type PropsType = {
    step: AiGenerationStepEnum;
    isSubmitDisabled: boolean;
    isGeneratingSuggest: boolean;
    isGeneratingImage: boolean;
    isGeneratingActiveImage: boolean;
    isApplying: boolean;
    hasActiveSuggest: boolean;
    onGenerate: () => void;
    onBack: () => void;
    onGenerateMore: () => void;
    onApply: () => void;
};

export function AiGenerationModalFooter(props: PropsType): JSX.Element | null {
    const {
        step,
        isSubmitDisabled,
        isGeneratingSuggest,
        isGeneratingImage,
        isGeneratingActiveImage,
        isApplying,
        hasActiveSuggest,
        onGenerate,
        onBack,
        onGenerateMore,
        onApply,
    } = props;

    // A new slide waits for any in-flight image: a second parallel image request would re-point
    // generatingImageIndex and orphan the previous slide's spinner. Only text generation spins the
    // button — an image regenerate blocks it without pretending ideas are being generated.
    const isGenerateMoreBlocked = isGeneratingSuggest || isGeneratingImage;

    // Applying only cares about the slide in view: sibling slides may still be waiting for images.
    const isActiveSlidePending = isGeneratingSuggest || isGeneratingActiveImage;

    if (step === AiGenerationStepEnum.Settings) {
        return (
            <Button disabled={isSubmitDisabled} onClick={onGenerate} type="primary">
                <Locale stringKey="POSTS_AI_GENERATION__SETUP__SUBMIT" />
            </Button>
        );
    }

    if (step === AiGenerationStepEnum.Result) {
        return (
            <div className={styles.AiGenerationModal_footer}>
                <Button onClick={onBack}>
                    <Locale stringKey="BUTTON__BACK" />
                </Button>

                <div className={styles.AiGenerationModal_generateMore}>
                    <AdditionalInfo placement="top">
                        <Locale
                            stringKey="POSTS_AI_GENERATION__RESULT__MAX_IDEAS_HINT"
                            valueMap={{count: AI_GENERATION_MAX_SLIDES}}
                        />
                    </AdditionalInfo>

                    <Button disabled={isGenerateMoreBlocked} loading={isGeneratingSuggest} onClick={onGenerateMore}>
                        <Locale stringKey="POSTS_AI_GENERATION__RESULT__GENERATE_MORE_IDEAS" />
                    </Button>
                </div>

                <Button
                    disabled={!hasActiveSuggest || isActiveSlidePending}
                    loading={isApplying}
                    onClick={onApply}
                    type="primary"
                >
                    <Locale stringKey="TEXT__SELECT" />
                </Button>
            </div>
        );
    }

    return null;
}
